'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherClock, FeatherGift, FeatherSend, FeatherX } from '@subframe/core';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { Button, IconButton } from '@/shared/components/ui';
import type { PresenteBoasVindasPersistido } from '@/shared/types/presenteBoasVindas';
import { lerPresenteBoasVindas, limparPresenteBoasVindas } from '@/shared/utils/presenteBoasVindas';
const ROTA_NOVA_NOTIFICACAO = '/notificacoes/criar/individual';
interface BannerPresenteBoasVindasProps {
  usuarioId: string;
}

/**
 * Banner do presente de boas-vindas na home, entregue pelo onboarding
 * self-service. Renderiza `null` quando não há presente pendente — a leitura do
 * `localStorage` só acontece depois da montagem para não divergir do HTML do
 * servidor durante a hidratação.
 */
export const BannerPresenteBoasVindas = t0 => {
  const $ = _c(40);
  const {
    usuarioId
  } = t0;
  const router = useRouter();
  const [presente, setPresente] = useState(null);
  let t1;
  let t2;
  if ($[0] !== usuarioId) {
    t1 = () => {
      setPresente(lerPresenteBoasVindas(usuarioId));
    };
    t2 = [usuarioId];
    $[0] = usuarioId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== usuarioId) {
    t3 = () => {
      limparPresenteBoasVindas(usuarioId);
      setPresente(null);
    };
    $[3] = usuarioId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const dispensar = t3;
  if (!presente) {
    return null;
  }
  let t4;
  if ($[5] !== presente.saldoNotificacoes) {
    t4 = presente.saldoNotificacoes.toLocaleString("pt-BR");
    $[5] = presente.saldoNotificacoes;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const bonusLabel = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="hp-dots hp-dots-brand" aria-hidden="true" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherGift className="text-brand-600 text-[22px]" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== bonusLabel) {
    t7 = <span className="text-brand-800 text-[32px] leading-none font-bold tracking-tight">{bonusLabel}</span>;
    $[9] = bonusLabel;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-[11px] font-semibold tracking-[0.06em] text-neutral-500 uppercase">de presente</span>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <div className="bg-brand-50 relative hidden items-center justify-center overflow-hidden border-r border-solid border-neutral-200 lg:flex">{t5}<span className="border-brand-100 hp-float relative z-10 flex flex-col items-center gap-2 rounded-[12px] border border-solid bg-white px-[22px] py-4 shadow-lg">{t6}{t7}{t8}</span></div>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="border-brand-100 bg-brand-50 text-brand-600 flex h-[22px] w-fit items-center rounded-[6px] border border-solid px-2 text-[11px] font-semibold tracking-[0.04em] uppercase">Presente de boas-vindas</span>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== bonusLabel) {
    t11 = <span className="text-default-font mt-0.5 text-lg leading-snug font-semibold text-pretty">{bonusLabel} notificações extrajudiciais já estão na sua conta</span>;
    $[15] = bonusLabel;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-sm leading-relaxed text-pretty text-neutral-500">Sem cartão, sem prazo escondido. Envie a primeira e veja o certificado de envio em minutos.</span>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11) {
    t13 = <div className="flex min-w-0 flex-col gap-1.5">{t10}{t11}{t12}</div>;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FeatherSend />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== router) {
    t15 = <Button size="medium" icon={t14} onClick={() => router.push(ROTA_NOVA_NOTIFICACAO)}>Enviar notificação agora</Button>;
    $[21] = router;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FeatherClock className="text-neutral-500" />;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== dispensar) {
    t17 = <Button variant="neutral-secondary" size="medium" icon={t16} onClick={dispensar}>Depois</Button>;
    $[24] = dispensar;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="text-xs leading-snug text-pretty text-neutral-400">Seu saldo continua na conta. Você acha em Notificações.</span>;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t15 || $[28] !== t17) {
    t19 = <div className="flex flex-wrap items-center gap-x-4 gap-y-3">{t15}{t17}{t18}</div>;
    $[27] = t15;
    $[28] = t17;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t13 || $[31] !== t19) {
    t20 = <div className="flex min-w-0 flex-col gap-4 py-6 pr-12 pl-6 sm:pl-7">{t13}{t19}</div>;
    $[30] = t13;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <FeatherX className="text-neutral-400" />;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== dispensar) {
    t22 = <IconButton variant="neutral-tertiary" size="small" className="absolute top-3 right-3" aria-label="Dispensar presente de boas-vindas" icon={t21} onClick={dispensar} />;
    $[34] = dispensar;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t20 || $[37] !== t22 || $[38] !== t9) {
    t23 = <div className="os-rise-in relative grid grid-cols-1 overflow-hidden rounded-[16px] border border-solid border-neutral-200 bg-white shadow-sm lg:grid-cols-[170px_minmax(0,1fr)]">{t9}{t20}{t22}</div>;
    $[36] = t20;
    $[37] = t22;
    $[38] = t9;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  return t23;
};